import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/favicon.ico")